// extracted by mini-css-extract-plugin
export default {"customerBenefitsContainer":"CustomerBenefitsWithBadges_customerBenefitsContainer__+GFEL","serviceBenefits":"CustomerBenefitsWithBadges_serviceBenefits__d8sna"};